<template>
  <div :style="{height: `${getRandomHeight()}px`}" class="ms-loader" v-if="loading">
    <spin size="large" />
  </div>
</template>

<script>
export default {
  props: ['loading'],
  methods: {
    getRandomHeight () {
      return Math.floor((Math.random() * 30) + 20)
    }
  }
}
</script>

<style>

</style>
